import { render, staticRenderFns } from "./LastEditsOptions.vue?vue&type=template&id=6ce9cb45&"
import script from "./LastEditsOptions.vue?vue&type=script&lang=js&"
export * from "./LastEditsOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports